// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__2n5CB","loader":"Loader_loader__iQ0cX","spin":"Loader_spin__3rpGA"};